import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useAuthStore } from '../store/store';

window.Pusher = Pusher;
Pusher.log = (msg) => {
    if (typeof msg === 'string' && msg.includes('Event recd')) {
        console.log('[Pusher]', msg);
    }
};

let echoInstance = null;

export const getEcho = () => {
    const token = useAuthStore.getState().token;
    if (!token) return null;

    if (!echoInstance) {
        echoInstance = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_PUSHER_KEY,
            cluster: process.env.REACT_APP_PUSHER_CLUSTER,
            forceTLS: true,
            authEndpoint: `${process.env.REACT_APP_API_URL}/api/broadcasting/auth`,
            auth: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        });
    }
    return echoInstance;
};

export const disconnectEcho = () => {
    if (echoInstance) {
        echoInstance.disconnect();
        echoInstance = null;
    }
};
